// 20.2.2.12 Math.cosh(x)
var $export = require('./_export')
  , exp     = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x){
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/core-js/modules/es6.math.cosh.js
// module id = ../../../../core-js/modules/es6.math.cosh.js
// module chunks = 3